<template>
  <div class="component">
    <form-status :v="$v" />
    <div class="row form-group">
      <div class="col-md-6"><strong>Please describe the support you are requesting </strong></div>
    </div>
    <div class="row form-group">
      <label class="col-md-12 required" for="supportTypeRequested"
        >Type of support requested :
        <tooltip
          content="For example, spare parts, technical publications such as Engine Manuals, technical inquiry support, etc. Please be as descriptive as possible."
          effect="scale"
          placement="right"
          ><i class="fa fa-question-circle"></i></tooltip
      ></label>
      <div class="col-md-4">
        <select
          v-model="productTypes.airframe.productInfo.acSysProduct"
          class="form-control"
          @blur="$v.productTypes.airframe.productInfo.acSysProduct.$touch()"
        >
          <option value="">Select Support Type</option>
          <option value="TechnicalData">Technical Data</option>
          <option value="SpareParts">Spare Parts</option>
          <option value="Other">Other</option>
        </select>
        <div v-if="$v.productTypes.airframe.productInfo.acSysProduct.$error" class="text-danger">
          Support description cannot be blank
        </div>
      </div>
    </div>

    <div v-if="productTypes.airframe.productInfo.acSysProduct === 'TechnicalData'" class="row form-group">
      <label class="col-md-12 required">Describe technical data requested</label>

      <div class="col-md-4">
        <input
          v-model.trim="productTypes.airframe.productInfo.acSysProductCommentsTechnical"
          type="text"
          class="form-control"
          @blur="$v.productTypes.airframe.productInfo.acSysProductCommentsTechnical.$touch()"
        />

        <div
          v-if="
            !$v.productTypes.airframe.productInfo.acSysProductCommentsTechnical.required &&
              $v.productTypes.airframe.productInfo.acSysProductCommentsTechnical.$error
          "
          class="text-danger"
        >
          This field cannot be blank
        </div>
        <div
          v-if="
            !$v.productTypes.airframe.productInfo.acSysProductCommentsTechnical.maxLength &&
              $v.productTypes.airframe.productInfo.acSysProductCommentsTechnical.$error
          "
          class="text-danger"
        >
          Allowed upto 100 characters only.
        </div>
      </div>
    </div>

    <div v-if="productTypes.airframe.productInfo.acSysProduct === 'SpareParts'" class="row form-group">
      <label class="col-md-12 required">Please list description and part numbers of spare parts being requested</label>
      <div class="col-md-4">
        <input
          v-model.trim="productTypes.airframe.productInfo.acSysProductCommentsParts"
          type="text"
          class="form-control"
          @blur="$v.productTypes.airframe.productInfo.acSysProductCommentsParts.$touch()"
        />
        <div
          v-if="
            !$v.productTypes.airframe.productInfo.acSysProductCommentsParts.required &&
              $v.productTypes.airframe.productInfo.acSysProductCommentsParts.$error
          "
          class="text-danger"
        >
          This field cannot be blank
        </div>
        <div
          v-if="
            !$v.productTypes.airframe.productInfo.acSysProductCommentsParts.maxLength &&
              $v.productTypes.airframe.productInfo.acSysProductCommentsParts.$error
          "
          class="text-danger"
        >
          Allowed upto 100 characters only.
        </div>
      </div>
    </div>

    <div v-if="productTypes.airframe.productInfo.acSysProduct === 'Other'" class="row form-group">
      <label class="col-md-12 required">Describe support being requested</label>
      <div class="col-md-4">
        <input
          v-model.trim="productTypes.airframe.productInfo.acSysProductCommentsOther"
          type="text"
          class="form-control"
          @blur="$v.productTypes.airframe.productInfo.acSysProductCommentsOther.$touch()"
        />
        <div
          v-if="
            !$v.productTypes.airframe.productInfo.acSysProductCommentsOther.required &&
              $v.productTypes.airframe.productInfo.acSysProductCommentsOther.$error
          "
          class="text-danger"
        >
          This field cannot be blank
        </div>
        <div
          v-if="
            !$v.productTypes.airframe.productInfo.acSysProductCommentsOther.maxLength &&
              $v.productTypes.airframe.productInfo.acSysProductCommentsOther.$error
          "
          class="text-danger"
        >
          Allowed upto 100 characters only.
        </div>
      </div>
    </div>

    <div class="row form-group">
      <label class="col-md-12" for="addSupportTypeRequested"
        >Additional equipment or parts for which you require support:
      </label>
      <div class="col-md-4">
        <textarea
          v-model="productTypes.airframe.productInfo.reqAddlPartSupport"
          class="form-control"
          name="addSupportTypeRequested"
        ></textarea>
        <div
          v-if="
            !$v.productTypes.airframe.productInfo.reqAddlPartSupport.maxLength &&
              $v.productTypes.airframe.productInfo.reqAddlPartSupport.$error
          "
          class="text-danger"
        >
          Allowed upto 500 characters only.
        </div>
      </div>
    </div>

    <div class="row form-group">
      <label for="productsPickList" class="required col-md-12">Product</label>
      <div class="col-md-4">
        <select
          v-model="productTypes.airframe.productInfo.reqEngineSupport"
          class="form-control"
          @blur="$v.productTypes.airframe.productInfo.reqEngineSupport.$touch()"
        >
          <option value="">Select Product</option>
          <option value="Airframe components">Airframe components</option>
          <option value="Dowty propellers">Dowty propellers</option>
        </select>
        <div v-if="$v.productTypes.airframe.productInfo.reqEngineSupport.$error" class="text-danger">
          Please select the product
        </div>
      </div>
    </div>

    <div class="form-group"><engine-details product-type="airframe" :v="$v" /></div>

    <div v-if="productTypes.airframe.companyDetails.companyTypeId == '4'" class="form-group row ">
      <div class="col-md-12">
        <label class="required" for="LetterOfDelegation">
          Please attach Letter of delegation from aircraft owner :
        </label>
        <!-- display uploaded file -->
        <file-upload
          upload-section="productInfo"
          document-type="LetterOfDelegation"
          :document-name="letterOfDelegation"
          product-type="airframe"
          :document-status="getDocumentStatus('LetterOfDelegation')"
          :v="$v.letterOfDelegation"
        />
      </div>
    </div>

    <div class="action-btns">
      <input type="submit" class="btn btn-sm btn-primary" value="Next" @click="gotoNextSection" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import tooltip from "build-ui-x/src/Tooltip";
import engineDetails from "@/mycfm/components/new-company/EngineDetails";
import fileUpload from "@/mycfm/components/new-company/FileUpload";
import { required, requiredIf, numeric, maxLength } from "vuelidate/lib/validators";
import formStatus from "@/mycfm/components/new-company/FormStatus";

export default {
  components: {
    tooltip,
    engineDetails,
    fileUpload,
    formStatus
  },
  data() {
    return {
      documentsRequired: false
    };
  },
  computed: {
    ...mapState("product", ["productTypes"]),
    letterOfDelegation() {
      let documentName = "";
      let storedDocs = this.$store.state.product.productTypes["airframe"].productInfo.documents;
      if (storedDocs != null && storedDocs.length != 0) {
        for (let i = 0; i < storedDocs.length; i++) {
          if (storedDocs[i].documentType == "LetterOfDelegation") {
            documentName = storedDocs[i].documentName;
            break;
          }
        }
      }
      return documentName;
    }
  },
  watch: {
    "productTypes.airframe.productInfo.maintServiceProvider": {
      handler: function(newVal) {
        if (newVal) {
          this.productTypes.airframe.productInfo.serviceProviderDetails = "";
          this.$v.productTypes.airframe.productInfo.serviceProviderDetails.$reset();
        }
      }
    },
    "productTypes.airframe.productInfo.acSysProduct": {
      handler: function() {
        this.$store.dispatch("product/clearAcSysProductFields");
        if (this.$store.state.product.productTypes.airframe.productInfo.acSysProduct === "SpareParts") {
          this.$v.productTypes.airframe.productInfo.acSysProductCommentsParts.$reset();
        }
        if (this.$store.state.product.productTypes.airframe.productInfo.acSysProduct === "TechnicalData") {
          this.$v.productTypes.airframe.productInfo.acSysProductCommentsTechnical.$reset();
        }
        if (this.$store.state.product.productTypes.airframe.productInfo.acSysProduct === "Other") {
          this.$v.productTypes.airframe.productInfo.acSysProductCommentsOther.$reset();
        }
      }
    }
  },
  created() {
    if (this.$store.state.vuealidate.hasOwnProperty("Product Information - Airframe Systems")) {
      this.$v.$touch();
    }
  },
  beforeDestroy() {
    this.$v.$touch();
    this.$store.dispatch("vuealidate/saveValidation", {
      componentName: "Product Information - Airframe Systems",
      $v: this.$v
    });
  },
  validations: {
    productTypes: {
      airframe: {
        productInfo: {
          engineDetails: {
            required,
            $each: {
              aircraftType: {
                required
              },
              otherAircraftType: {
                required: requiredIf(function(engine) {
                  return engine.aircraftType === "Other";
                })
              },
              aircraftNumber: {
                required: requiredIf(function() {
                  return this.$store.state.product.productTypes["airframe"].companyDetails.companyTypeId != "6";
                }),
                numeric,
                maxLength: maxLength(8)
              }
            }
          },
          acSysProductCommentsParts: {
            required: requiredIf(function() {
              return this.productTypes.airframe.productInfo.acSysProduct === "SpareParts";
            }),
            maxLength: maxLength(100)
          },
          acSysProductCommentsTechnical: {
            required: requiredIf(function() {
              return this.productTypes.airframe.productInfo.acSysProduct === "TechnicalData";
            }),
            maxLength: maxLength(100)
          },
          acSysProductCommentsOther: {
            required: requiredIf(function() {
              return this.productTypes.airframe.productInfo.acSysProduct === "Other";
            }),
            maxLength: maxLength(100)
          },
          acSysProduct: {
            required
          },
          reqAddlPartSupport: {
            maxLength: maxLength(250)
          },
          reqEngineSupport: {
            required
          },
          serviceProviderDetails: {
            required: requiredIf(function() {
              return this.productTypes.airframe.productInfo.maintServiceProvider == "yes";
            })
          }
        }
      }
    },
    letterOfDelegation: {
      required: requiredIf(function() {
        return this.$store.state.product.productTypes["airframe"].companyDetails.companyTypeId == "4";
      })
    }
  },
  methods: {
    getDocumentStatus(docType) {
      let status = "";
      let storedDocs = this.$store.state.product.productTypes["airframe"].productInfo.documents;
      if (storedDocs != null && storedDocs.length != 0) {
        for (let i = 0; i < storedDocs.length; i++) {
          if (storedDocs[i].documentType == docType) {
            status = storedDocs[i].status;
            break;
          }
        }
      }
      return status;
    },
    gotoNextSection() {
      this.$emit("next", "ProductInfoAirframe");
    }
  }
};
</script>
